<template>
  <div class="cart-entry-shell" style="height: 100% !important">
    <cart-entry-desktop v-if="!isMobileCartEntry" />
    <cart-entry-mobile v-else />
  </div>
</template>

<script>
import CartEntryDesktop from "./CartEntryDesktop.vue";
import CartEntryMobile from "./CartEntryMobile.vue";

/** Masaüstü şablonu birebir CartEntryDesktop’ta; mobil CartEntryMobile. Eşik: 767px. */
export default {
  name: "CartEntry",
  components: {
    CartEntryDesktop,
    CartEntryMobile,
  },
  data() {
    return {
      isMobileCartEntry: false,
      _cartEntryMq: null,
      _cartEntryMqHandler: null,
    };
  },
  mounted() {
    const mq = window.matchMedia("(max-width: 767px)");
    this._cartEntryMq = mq;
    this.isMobileCartEntry = mq.matches;
    const handler = () => {
      this.isMobileCartEntry = mq.matches;
    };
    this._cartEntryMqHandler = handler;
    if (typeof mq.addEventListener === "function") {
      mq.addEventListener("change", handler);
    } else if (typeof mq.addListener === "function") {
      mq.addListener(handler);
    }
  },
  beforeDestroy() {
    const mq = this._cartEntryMq;
    const handler = this._cartEntryMqHandler;
    if (mq && handler) {
      if (typeof mq.removeEventListener === "function") {
        mq.removeEventListener("change", handler);
      } else if (typeof mq.removeListener === "function") {
        mq.removeListener(handler);
      }
    }
  },
};
</script>
